
    import {Component, Prop, Vue, Emit, Watch} from 'vue-property-decorator';
    // @ts-ignore
    import {getAllTemple} from "@/api/public"
    @Component
    export default class SearchTemple extends Vue {
      private options: any = {}
      private value: string=''
      @Emit('getTemple')
      sendTemple(value: number) {}
      private getAll():any{
        getAllTemple()
         .then((res:any)=>{
           if(res.code===200){
             this.options=res.data;
           }
         })
      }

      public mounted():void{
        this.getAll();
      }
    }
